import { useCallback, useRef } from 'react';

/**
 * Creates a stable reference callback that always calls the latest version of the provided function.
 * This is useful when you need to call fresh callbacks in async functions, where the initial callback is not the latest.
 * Similar to React's experimental useEvent hook.
 */
export const useReferenceCallback = <Args extends any[], Return>(
  callback: (...args: Args) => Return,
): ((...args: Args) => Return) => {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  return useCallback((...args: Args) => callbackRef.current(...args), []);
};
